<template>
  <!-- Confirm-pattern wrapper over AppDialog. Parents mount it with `v-if` and
       close it from @confirm / @cancel, so the dialog is always open while mounted. -->
  <AppDialog
    :model-value="true"
    :title="title"
    :confirm-text="confirmButtonText"
    :cancel-text="cancelButtonText"
    @confirm="$emit('confirm')"
    @cancel="$emit('cancel')"
  >
    <p class="confirmation-message">{{ message }}</p>
    <slot name="body"></slot>
  </AppDialog>
</template>

<script>
import AppDialog from '@/components/AppDialog.vue';

export default {
  components: { AppDialog },
  props: {
    message: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    confirmButtonText: {
      type: String,
      required: true,
    },
    cancelButtonText: {
      type: String,
      required: true,
    },
  },
  emits: ['confirm', 'cancel'],
};
</script>

<style scoped>
.confirmation-message {
  margin-bottom: 12px;
}
</style>
